/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from Numeric.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace Numeric.
 * @public
 */

goog.module('Numeric.incrementaldom');

goog.require('goog.soy.data.SanitizedContent');
var incrementalDom = goog.require('incrementaldom');
goog.require('soy.asserts');
var soyIdom = goog.require('soy.idom');

var $templateAlias1 = Soy.getTemplate('FieldBase.incrementaldom', 'render');


/**
 * @param {{
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  _handleFieldBlurred: (*|null|undefined),
 *  _handleFieldChanged: (*|null|undefined),
 *  _handleFieldFocused: (*|null|undefined),
 *  _value: (*|null|undefined),
 *  displayErrors: (boolean|null|undefined),
 *  errorMessage: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  label: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  placeholder: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  predefinedValue: (*|null|undefined),
 *  readOnly: (boolean|null|undefined),
 *  repeatable: (boolean|null|undefined),
 *  required: (boolean|null|undefined),
 *  showLabel: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  tip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  tooltip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  valid: (boolean|null|undefined),
 *  visible: (boolean|null|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $render(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var name = soy.asserts.assertType(goog.isString(opt_data.name) || opt_data.name instanceof goog.soy.data.SanitizedContent, 'name', opt_data.name, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleFieldBlurred = opt_data._handleFieldBlurred;
  /** @type {*|null|undefined} */
  var _handleFieldChanged = opt_data._handleFieldChanged;
  /** @type {*|null|undefined} */
  var _handleFieldFocused = opt_data._handleFieldFocused;
  /** @type {*|null|undefined} */
  var _value = opt_data._value;
  /** @type {boolean|null|undefined} */
  var displayErrors = soy.asserts.assertType(opt_data.displayErrors == null || (goog.isBoolean(opt_data.displayErrors) || opt_data.displayErrors === 1 || opt_data.displayErrors === 0), 'displayErrors', opt_data.displayErrors, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var errorMessage = soy.asserts.assertType(opt_data.errorMessage == null || (goog.isString(opt_data.errorMessage) || opt_data.errorMessage instanceof goog.soy.data.SanitizedContent), 'errorMessage', opt_data.errorMessage, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var id = soy.asserts.assertType(opt_data.id == null || (goog.isString(opt_data.id) || opt_data.id instanceof goog.soy.data.SanitizedContent), 'id', opt_data.id, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var label = soy.asserts.assertType(opt_data.label == null || (goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent), 'label', opt_data.label, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var placeholder = soy.asserts.assertType(opt_data.placeholder == null || (goog.isString(opt_data.placeholder) || opt_data.placeholder instanceof goog.soy.data.SanitizedContent), 'placeholder', opt_data.placeholder, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {*|null|undefined} */
  var predefinedValue = opt_data.predefinedValue;
  /** @type {boolean|null|undefined} */
  var readOnly = soy.asserts.assertType(opt_data.readOnly == null || (goog.isBoolean(opt_data.readOnly) || opt_data.readOnly === 1 || opt_data.readOnly === 0), 'readOnly', opt_data.readOnly, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var repeatable = soy.asserts.assertType(opt_data.repeatable == null || (goog.isBoolean(opt_data.repeatable) || opt_data.repeatable === 1 || opt_data.repeatable === 0), 'repeatable', opt_data.repeatable, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var required = soy.asserts.assertType(opt_data.required == null || (goog.isBoolean(opt_data.required) || opt_data.required === 1 || opt_data.required === 0), 'required', opt_data.required, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var showLabel = soy.asserts.assertType(opt_data.showLabel == null || (goog.isBoolean(opt_data.showLabel) || opt_data.showLabel === 1 || opt_data.showLabel === 0), 'showLabel', opt_data.showLabel, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var tip = soy.asserts.assertType(opt_data.tip == null || (goog.isString(opt_data.tip) || opt_data.tip instanceof goog.soy.data.SanitizedContent), 'tip', opt_data.tip, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var tooltip = soy.asserts.assertType(opt_data.tooltip == null || (goog.isString(opt_data.tooltip) || opt_data.tooltip instanceof goog.soy.data.SanitizedContent), 'tooltip', opt_data.tooltip, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var type = soy.asserts.assertType(opt_data.type == null || (goog.isString(opt_data.type) || opt_data.type instanceof goog.soy.data.SanitizedContent), 'type', opt_data.type, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var valid = soy.asserts.assertType(opt_data.valid == null || (goog.isBoolean(opt_data.valid) || opt_data.valid === 1 || opt_data.valid === 0), 'valid', opt_data.valid, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var visible = soy.asserts.assertType(opt_data.visible == null || (goog.isBoolean(opt_data.visible) || opt_data.visible === 1 || opt_data.visible === 0), 'visible', opt_data.visible, 'boolean|null|undefined');
  var param2746 = function() {
    $content({_handleFieldBlurred: _handleFieldBlurred, _handleFieldChanged: _handleFieldChanged, _handleFieldFocused: _handleFieldFocused, id: id, name: name, placeholder: placeholder, predefinedValue: predefinedValue, readOnly: readOnly, value: _value}, null, opt_ijData);
  };
  $templateAlias1({contentRenderer: param2746, displayErrors: displayErrors, errorMessage: errorMessage, id: id, label: label, name: name, repeatable: repeatable, required: required, showLabel: showLabel, spritemap: spritemap, tip: tip, tooltip: tooltip, type: type, valid: valid, visible: visible}, null, opt_ijData);
}
exports.render = $render;
/**
 * @typedef {{
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  _handleFieldBlurred: (*|null|undefined),
 *  _handleFieldChanged: (*|null|undefined),
 *  _handleFieldFocused: (*|null|undefined),
 *  _value: (*|null|undefined),
 *  displayErrors: (boolean|null|undefined),
 *  errorMessage: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  label: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  placeholder: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  predefinedValue: (*|null|undefined),
 *  readOnly: (boolean|null|undefined),
 *  repeatable: (boolean|null|undefined),
 *  required: (boolean|null|undefined),
 *  showLabel: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  tip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  tooltip: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  valid: (boolean|null|undefined),
 *  visible: (boolean|null|undefined)
 * }}
 */
$render.Params;
if (goog.DEBUG) {
  $render.soyTemplateName = 'Numeric.render';
}


/**
 * @param {{
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  _handleFieldBlurred: (*|null|undefined),
 *  _handleFieldChanged: (*|null|undefined),
 *  _handleFieldFocused: (*|null|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  placeholder: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  predefinedValue: (*|null|undefined),
 *  readOnly: (boolean|null|undefined),
 *  value: (*|null|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $content(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var name = soy.asserts.assertType(goog.isString(opt_data.name) || opt_data.name instanceof goog.soy.data.SanitizedContent, 'name', opt_data.name, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleFieldBlurred = opt_data._handleFieldBlurred;
  /** @type {*|null|undefined} */
  var _handleFieldChanged = opt_data._handleFieldChanged;
  /** @type {*|null|undefined} */
  var _handleFieldFocused = opt_data._handleFieldFocused;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var id = soy.asserts.assertType(opt_data.id == null || (goog.isString(opt_data.id) || opt_data.id instanceof goog.soy.data.SanitizedContent), 'id', opt_data.id, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var placeholder = soy.asserts.assertType(opt_data.placeholder == null || (goog.isString(opt_data.placeholder) || opt_data.placeholder instanceof goog.soy.data.SanitizedContent), 'placeholder', opt_data.placeholder, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {*|null|undefined} */
  var predefinedValue = opt_data.predefinedValue;
  /** @type {boolean|null|undefined} */
  var readOnly = soy.asserts.assertType(opt_data.readOnly == null || (goog.isBoolean(opt_data.readOnly) || opt_data.readOnly === 1 || opt_data.readOnly === 0), 'readOnly', opt_data.readOnly, 'boolean|null|undefined');
  /** @type {*|null|undefined} */
  var value = opt_data.value;
  var attributes__soy2785 = function() {
    incrementalDom.attr('class', 'form-control');
    incrementalDom.attr('data-onblur', _handleFieldBlurred);
    incrementalDom.attr('data-onfocus', _handleFieldFocused);
    incrementalDom.attr('data-oninput', _handleFieldChanged);
    if (readOnly) {
      incrementalDom.attr('disabled', 'disabled');
    }
    if (id) {
      incrementalDom.attr('id', id);
    } else {
      incrementalDom.attr('id', name);
    }
    incrementalDom.attr('name', name);
    if (placeholder) {
      incrementalDom.attr('placeholder', placeholder);
    }
    incrementalDom.attr('type', 'text');
    if (value) {
      incrementalDom.attr('value', value);
    } else if (predefinedValue) {
      incrementalDom.attr('value', predefinedValue);
    } else {
      incrementalDom.attr('value', '');
    }
  };
  incrementalDom.elementOpenStart('input');
      attributes__soy2785();
  incrementalDom.elementOpenEnd();
  incrementalDom.elementClose('input');
}
exports.content = $content;
/**
 * @typedef {{
 *  name: (!goog.soy.data.SanitizedContent|string),
 *  _handleFieldBlurred: (*|null|undefined),
 *  _handleFieldChanged: (*|null|undefined),
 *  _handleFieldFocused: (*|null|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  placeholder: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  predefinedValue: (*|null|undefined),
 *  readOnly: (boolean|null|undefined),
 *  value: (*|null|undefined)
 * }}
 */
$content.Params;
if (goog.DEBUG) {
  $content.soyTemplateName = 'Numeric.content';
}

exports.render.params = ["name","_handleFieldBlurred","_handleFieldChanged","_handleFieldFocused","_value","displayErrors","errorMessage","id","label","placeholder","predefinedValue","readOnly","repeatable","required","showLabel","spritemap","tip","tooltip","type","valid","visible"];
exports.render.types = {"name":"string","_handleFieldBlurred":"any","_handleFieldChanged":"any","_handleFieldFocused":"any","_value":"any","displayErrors":"bool","errorMessage":"string","id":"string","label":"string","placeholder":"string","predefinedValue":"any","readOnly":"bool","repeatable":"bool","required":"bool","showLabel":"bool","spritemap":"string","tip":"string","tooltip":"string","type":"string","valid":"bool","visible":"bool"};
exports.content.params = ["name","_handleFieldBlurred","_handleFieldChanged","_handleFieldFocused","id","placeholder","predefinedValue","readOnly","value"];
exports.content.types = {"name":"string","_handleFieldBlurred":"any","_handleFieldChanged":"any","_handleFieldFocused":"any","id":"string","placeholder":"string","predefinedValue":"any","readOnly":"bool","value":"any"};
templates = exports;
return exports;

});

class Numeric extends Component {}
Soy.register(Numeric, templates);
export { Numeric, templates };
export default templates;
/* jshint ignore:end */
